import React, { useState, useEffect } from 'react'
import { isTokenInvalidOrAbsent } from 'src/views/pages/login/ProtectedRoute'
import { getData } from '../services/profileService'
import { logoutHandler } from '../services/loginLogoutHandlers'
import { useNavigate } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { getSetupData } from 'src/reducers/setupData/services/setupDataThunk'
import { selectSetupData } from 'src/reducers/setupData/setupDataReducer'
import { REDUX_STATUS_LOADING } from '../constants'
import { shouldSkipSecureSetupOnPortalRoutingPage } from 'src/shared/auth/loginHandoff'

function parseStoredConfig(value) {
  if (typeof value !== 'string' || !value.trim()) {
    return null
  }

  try {
    return JSON.parse(value)
  } catch (error) {
    return null
  }
}

export const SetupContext = React.createContext()

export const SetupContextProvider = ({ children }) => {
  // const [setupData, setSetupData] = useState(null)
  // const [setupLoading, setSetupLoading] = useState(false)
  // const [setupError, setSetupError] = useState()
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const setupDataState = useSelector(selectSetupData)
  const setupData = setupDataState?.data
  const setupError = setupDataState?.error
  const setupLoading = setupDataState?.status === REDUX_STATUS_LOADING

  useEffect(() => {
    const token = localStorage.getItem('token')
    const currentPath = window.location.pathname
    const authorities = localStorage.getItem('authorities')
    
    // Skip setup API call for live session routes - setupData is not needed on these routes
    // Paywall component can load setupData lazily when actually opened
    if (
      currentPath.startsWith('/l/') ||
      currentPath.startsWith('/mentor-home/l/') ||
      currentPath.startsWith('/live/') ||
      currentPath.startsWith('/webinar/')
    ) {
      return // Don't fetch setup data for these routes
    }

    if (
      shouldSkipSecureSetupOnPortalRoutingPage(authorities, {
        pathname: currentPath,
        explicitlyChoseConsumerPortal:
          sessionStorage.getItem('explicitlyChoseConsumerPortal') === 'true',
        lastChosenFlow: localStorage.getItem('lastChosenFlow'),
        kioskConfig: parseStoredConfig(localStorage.getItem('kiosk-config')),
        roleCaConfig: parseStoredConfig(localStorage.getItem('ROLE_CA_CONFIG')),
      })
    ) {
      return
    }
    
    if (!isTokenInvalidOrAbsent(token)) {
      dispatch(getSetupData({ navigate }))
    }

    // if (!isTokenInvalidOrAbsent(token)) {
    //   const fetchSetupData = async () => {
    //     try {
    //       setSetupLoading(true)
    //       const resp = await getData('/api/secure/setup')
    //       setSetupLoading(false)
    //       if (resp?.status === 200) {
    //         setSetupData(resp.data)
    //       } else if (resp?.status === 401) {
    //         logoutHandler()
    //         navigate('/')
    //       }
    //     } catch (error) {
    //       setSetupError(error)
    //       // Handle any errors from the data fetching here
    //     }
    //   }
    //   fetchSetupData()
    // }
  }, []) // The empty dependency array ensures this effect runs only once

  useEffect(() => {
    // console.log(setupData)
  }, [setupData])

  return (
    <SetupContext.Provider value={{ setupLoading, setupData, setupError }}>
      {children}
    </SetupContext.Provider>
  )
}
